import "../_namespaces.js";
import "./base.js";
import "../collections/questions.js";
import "../collections/completion_pages.js";

window.AssessmentViewer ??= {};
window.AssessmentViewer.Models ??= {};

AssessmentViewer.Models.Assessment = class Assessment extends AssessmentViewer.Models.Base {
  constructor() {
    super(...arguments);
    this.getSubmitterInfo = this.getSubmitterInfo.bind(this);
    this.completionPageLink = this.completionPageLink.bind(this);
    this.completionPageForScore = this.completionPageForScore.bind(this);
    this.calculateScore = this.calculateScore.bind(this);
    this.getQuestionsWithSelectedResponse = this.getQuestionsWithSelectedResponse.bind(this);
  }

  defaults() {
    return {
      firstName: null,
      lastName: null,
      emailAddress: null,
      birthday: null,
      phoneNumber: null,
      zipCode: null,
    };
  }

  // HELPER FUNCTIONS

  getSubmitterInfo() {
    return {
      firstName: this.get("firstName"),
      lastName: this.get("lastName"),
      emailAddress: this.get("emailAddress"),
      birthday: this.get("birthday"),
      phoneNumber: this.get("phoneNumber"),
      zipCode: this.get("zipCode"),
    };
  }

  completionPageLink() {
    const completionPage = this.completionPageForScore(this.calculateScore());
    if (completionPage) {
      return completionPage.get("url");
    }
  }

  completionPageForScore(score) {
    return this.get("completionPages").find((completionPage) => completionPage.scoreWithinRange(score));
  }

  calculateScore() {
    switch (this.get("scoring")) {
      case "average":
        return AssessmentViewer.Scoring.Average.calculate(
          _.map(this.getQuestionsWithSelectedResponse(), (question) =>
            AssessmentViewer.Scoring.Average.calculate(question.selectedResponsePoints()),
          ),
        );
      case "sum":
        return AssessmentViewer.Scoring.Sum.calculate(
          _.map(this.getQuestionsWithSelectedResponse(), (question) =>
            AssessmentViewer.Scoring.Sum.calculate(question.selectedResponsePoints()),
          ),
        );
    }
  }

  getQuestionsWithSelectedResponse() {
    return this.get("questions").filter((question) => question.hasSelectedResponse());
  }
};

AssessmentViewer.Models.Assessment.prototype.relations = [
  {
    type: Backbone.HasMany,
    key: "questions",
    relatedModel: "AssessmentViewer.Models.Question",
    collectionType: "AssessmentViewer.Collections.Questions",
    reverseRelation: {
      key: "assessment",
      includeInJSON: false,
    },
  },
  {
    type: Backbone.HasMany,
    key: "completionPages",
    relatedModel: "AssessmentViewer.Models.CompletionPage",
    collectionType: "AssessmentViewer.Collections.CompletionPages",
    reverseRelation: {
      key: "assessment",
      includeInJSON: false,
    },
  },
];

AssessmentViewer.Models.Assessment.initializeRelations();
